module.exports = __webpack_public_path__ + "static/media/mail.d3c9a2ce.svg";